<template>
  <div class="grey lighten-3 py-5 px-5">
    <h1>Add new Text</h1>
    <v-flex xs4 sm4 md4 mb-3> </v-flex>

    <v-stepper v-model="e1" class="elevation-1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">
          Basic Text Info
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">
          Write/Upload Text</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 3" step="3">
          Assign Artworks & Artists</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step step="4">Summary</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="mb-3 elevation-0">
            <v-form @submit.prevent ref="form">
              <!-- <v-card class="px-3 pt-4 mt-4 elevation-0 editBG"> -->
              <v-container grid-list-md fluid>
                <v-layout row wrap>
                  <v-flex
                    style="background-color:#292929; color: #eee;"
                    class="px-3 py-1 my-2 elevation-0 xs12"
                  >
                    <h3 class="font-weight-bold subtitle xs12 flex">Basic</h3>
                  </v-flex>

                  <v-flex xs12 class="px-2">
                    <v-text-field
                      v-model="text.given_filename"
                      label="File Name"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md6 class="px-2">
                    <v-text-field
                      v-model="text.title"
                      label="Title Publication"
                    ></v-text-field>
                  </v-flex>

                  <!-- <v-flex xs12 md6 class="px-4">
                    <v-text-field
                      v-model="text.title"
                      label="Title "
                    ></v-text-field>
                  </v-flex> -->

                  <v-flex xs12 md6 class="px-2">
                    <v-text-field
                      v-model="text.editor"
                      label="Editor"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      v-model="text.authors"
                      label="Author(s)"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      v-model="text.year"
                      label="Year"
                      mask="####"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      v-model="text.place"
                      label="Place"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      v-model="text.publisher"
                      label="Publisher"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 class="px-2">
                    <v-text-field
                      v-model="text.url"
                      label="URL (link)"
                    ></v-text-field>
                  </v-flex>

                  <!-- outline -->
                  <v-flex xs12 sm6 px-2>
                    <v-textarea
                      v-model="text.notes"
                      label="Notes"
                      auto-grow
                      clearable
                      rows="1"
                    ></v-textarea>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pl-0 pb-4">
                    <v-flex xs12 sm6 class="py-2">
                      <h4
                        class="body-2 mt-0 mb-1 ml-2 grey--text text--darken-2"
                      >
                        Format
                      </h4>
                      <v-btn-toggle v-model="text.text_type">
                        <v-btn
                          small
                          flat
                          key="print"
                          class="px-2"
                          input-value="print"
                          value="print"
                        >
                          <span> Print </span>
                        </v-btn>
                        <v-btn
                          small
                          flat
                          key="online"
                          class="px-2"
                          input-value="online"
                          value="online"
                        >
                          <span> Online </span>
                        </v-btn>
                      </v-btn-toggle>
                    </v-flex>
                  </v-flex>

                  <v-flex xs12 md6 class="py-4">
                    <h4 class="body-2 mt-0 mb-1 ml-2 grey--text text--darken-2">
                      Ownership
                    </h4>
                    <v-btn-toggle v-model="text.tba">
                      <v-btn
                        small
                        flat
                        key="tba"
                        class="px-2"
                        input-value="tba"
                        value="tba"
                      >
                        <span> TBA </span>
                      </v-btn>
                      <v-btn
                        small
                        flat
                        key="nontba"
                        class="px-2"
                        input-value="nontba"
                        value="nontba"
                      >
                        <span> NON TBA </span>
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>

                  <v-flex
                    style="background-color:#292929; color: #eee;"
                    class="px-3 py-1 my-2 elevation-0 xs12"
                  >
                    <h3 class="font-weight-bold subtitle xs12 flex">
                      Type of text / resource
                    </h3>
                  </v-flex>

                  <!-- <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
                    <v-checkbox
                      color="black"
                      v-model="text.tba"
                      hide-details
                      label="TBA21 publication"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
                    <v-checkbox
                      color="black"
                      v-model="text.nontba"
                      hide-details
                      label="NON TBA21 publication"
                    ></v-checkbox>
                  </v-flex> -->

                  <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
                    <v-checkbox
                      color="black"
                      v-model="text.article"
                      hide-details
                      label="Article (magazine, journal, etc)"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
                    <v-checkbox
                      color="black"
                      v-model="text.artwork_text"
                      hide-details
                      label="Text on artwork (exhibition, website, social media etc)"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
                    <v-checkbox
                      color="black"
                      v-model="text.pr"
                      hide-details
                      label="Press release"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
                    <v-checkbox
                      color="black"
                      v-model="text.artist_documents"
                      hide-details
                      label="Documents received from artist, gallery, etc"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 md6 lg4 py-0 my-0 class="pl-4">
                    <v-checkbox
                      color="black"
                      v-model="text.transcript"
                      hide-details
                      label="Transcription"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 md6 lg4 py-0 mb-0 class="pl-4">
                    <v-checkbox
                      color="black"
                      v-model="text.work_text"
                      hide-details
                      label="Work inherent text (part of artwork)"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 md6 lg4 py-0 mb-5 class="pl-4">
                    <v-checkbox
                      color="black"
                      v-model="text.publication"
                      hide-details
                      label="Publication"
                    ></v-checkbox>
                  </v-flex>

                  <v-layout align-center justify-end mt-5 v-if="valid">
                    <!-- <v-btn color="primary" @click="saveText()">SAVE & NEXT</v-btn> -->
                    <!-- :disabled="!approved" -->
                    <v-btn color="primary" @click.native="saveText">Next</v-btn>
                    <v-btn @click="$router.go(-1)" outline flat>Cancel</v-btn>
                    <!-- <v-btn color="black" outline @click="$router.go(-1)">CANCEL</v-btn> -->
                  </v-layout>
                  <!-- <v-layout align-center justify-end mr-3>
                      <v-btn color="red" outline @click="deleteText()">delete</v-btn>
                    </v-layout> -->
                </v-layout>
              </v-container>
              <!-- </v-card> -->
            </v-form>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card class="mb-3 elevation-0">
            <v-flex xs12 mx-3 mt-4>
              <upload
                uploadCategory="text"
                :id="text.id"
                :field="{
                  title: 'Uploaded Artwork Text',
                  name: 'artwork_text',
                  category: 'artwork_text'
                }"
              ></upload>
            </v-flex>

            <v-form @submit.prevent ref="form">
              <!-- <v-card class="px-3 pt-4 mt-4 elevation-0 editBG"> -->
              <v-container grid-list-xs fluid>
                <v-layout row wrap>
                  <v-flex xs12 mx-0 mt-2>
                    <v-container grid-list-xs fluid px-0>
                      <v-layout row wrap>
                        <!-- <v-text-field v-model="text.title" class="flex xs12 ml-0 mb-3" outline name="Text Title" label="Text Title"></v-text-field> -->
                        <text-editor
                          @input="text.content = $event"
                        ></text-editor>
                      </v-layout>
                    </v-container>
                  </v-flex>

                  <v-layout align-center justify-end mt-5 v-if="valid">
                    <v-btn color="primary" @click="updateText()">Next</v-btn>
                    <!-- :disabled="!approved" -->
                    <!-- <v-btn color="primary" @click.native="e1 = 2">Next</v-btn> -->
                    <v-btn @click="$router.go(-1)" outline>Cancel</v-btn>
                    <!-- <v-btn color="black" outline @click="$router.go(-1)">CANCEL</v-btn> -->
                  </v-layout>
                  <!-- <v-layout align-center justify-end mr-3>
                      <v-btn color="red" outline @click="deleteText()">delete</v-btn>
                    </v-layout> -->
                </v-layout>
              </v-container>
              <!-- </v-card> -->
            </v-form>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card color="grey lighten-4" class="mb-5 pb-1">
            <!-- <v-card-title>Artwork Details</v-card-title> -->

            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12 sm12>
                  <!-- <v-flex xs12 px-4>
                    <v-autocomplete
                      v-model="text.artworks"
                      :items="artworks"
                      label="Artworks"
                      item-text="title"
                      item-value="id"
                      multiple
                      chips
                    ></v-autocomplete>
                  </v-flex> -->

                  <!-- @input="getArwork(temp_artwork)" -->
                  <!-- @blur="search=''" -->
                  <!-- open-on-clear -->
                  <v-autocomplete
                    v-model="text.artworks"
                    :search-input.sync="search"
                    box
                    color="grey lighten-1"
                    chips
                    multiple
                    :items="artworks"
                    :item-text="
                      item =>
                        item.title +
                        ', ' +
                        item.accession_number +
                        ', ' +
                        item.name
                    "
                    item-value="id"
                    label="Select Artworks related to this Text"
                    menu-props='{"closeOnClick":true, "closeOnContentClick":false, "openOnClick":false, "maxHeight":600}'
                  >
                    <!-- prepend-icon="filter_list" -->
                    <!-- <template v-slot:item="data">
                      <div
                        :key="data.item.id"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        @input="data.parent.selectItem(data.item)"
                      >
                      <v-checkbox value="data.item.selected"></v-checkbox>
                        {{ data.item.title }}
                      </div>
                    </template> -->
                    <template v-slot:selection="data">
                      <v-chip
                        :selected="data.selected"
                        close
                        class="chip--select-multi white--text chip--select-multi"
                        color="black"
                        @input="remove(data.item.id)"
                      >
                        <strong v-html="data.item.title"></strong>&nbsp;
                        <span>{{ data.item.accession_number }} </span>&nbsp;
                        <strong
                          v-html="
                            data.item.artist
                              ? data.item.artist.name
                              : data.item.name
                          "
                        ></strong>
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <strong v-html="data.item.title"></strong>&nbsp;
                          <span>{{ data.item.accession_number }} </span>&nbsp;
                          <strong v-html="data.item.name"></strong>
                        </v-list-tile-title>
                        <v-list-tile-sub-title></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>

                  <!-- <v-autocomplete item-text="title" item-value="id" label="Select Artwork to add to this Text."
                    :items="artworks"
                    v-model="temp_artwork"
                    @input="getArwork(temp_artwork)"
                  ></v-autocomplete> -->
                </v-flex>

                <v-flex xs12 sm12>
                  <!-- <div title class="pt-0 ml-0 mb-2 mt-0" v-if="text_artworks">
                    <h3>Artworks ({{ text_artworks.length }})</h3>
                  </div> -->

                  <v-list two-line class="mx-0 mb-4 xs12">
                    <!-- <template v-for="(item, index) in text_artworks"> -->
                    <!-- <v-divider :key="index" ></v-divider> -->
                    <v-list-tile :key="item.id" v-for="item in text_artworks">
                      <v-list-tile-avatar>
                        <img
                          v-if="item.top_photo_id > 0"
                          v-bind:src="
                            `${this.$globals.apiserver}/data/artwork/${item.id}/${item.top_photo_id}_th_big.jpg`
                          "
                        />
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title
                          v-html="`${item.title} (${item.production_date_new})`"
                        ></v-list-tile-title>
                        <v-list-tile-sub-title
                          v-html="item.full_name"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <!-- </template> -->
                  </v-list>
                </v-flex>

                <v-flex xs12 sm12>
                  <v-autocomplete
                    v-model="text.artists"
                    multiple
                    open-on-clear
                    box
                    chips
                    color="grey lighten-1"
                    :items="artists"
                    :item-text="
                      item =>
                        item.name + ', ' + item.full_name + ', ' + item.company
                    "
                    item-value="id"
                    label="Select Artists to add to this Text"
                    menu-props='{"closeOnClick":true, "closeOnContentClick":false, "openOnClick":false, "maxHeight":600}'
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :selected="data.selected"
                        color="black"
                        class="chip--select-multi white--text chip--select-multi"
                        close
                        @input="removeArtist(data.item.id)"
                      >
                        <strong v-html="data.item.name"></strong>&nbsp;
                        <span>{{ data.item.full_name }} </span>&nbsp;
                        <strong v-html="data.item.company"></strong>
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <!-- <v-list-tile-avatar>
                        <img :src="data.item.avatar">
                      </v-list-tile-avatar> -->
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <strong v-html="data.item.name"></strong>&nbsp;
                          <!-- <span>{{ data.item.accession_number }} </span>&nbsp;
                          <strong v-html="data.item.name"></strong> -->
                        </v-list-tile-title>
                        <v-list-tile-sub-title></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm12>
                  <!-- <div title class="pt-0 ml-0 mb-2 mt-0" v-if="text_artists">
                    <h3>Artists ({{ text_artists.length }})</h3>
                  </div> -->

                  <v-list two-line class="mx-0 mb-4 xs12">
                    <!-- <template v-for="(item, index) in text_artworks"> -->
                    <!-- <v-divider :key="index" ></v-divider> -->
                    <v-list-tile :key="item.id" v-for="item in text_artists">
                      <!-- <v-list-tile-avatar>
                        <img
                          v-if="item.top_photo_id > 0"
                          v-bind:src="
                            'http://tb-cms.org/data/artwork/' +
                              item.id +
                              '/' +
                              item.top_photo_id +
                              '_th_big.jpg'
                          "
                        />
                      </v-list-tile-avatar> -->
                      <v-list-tile-content>
                        <v-list-tile-title
                          v-html="item.name"
                        ></v-list-tile-title>
                        <!-- <v-list-tile-sub-title
                          v-html="item.full_name"
                        ></v-list-tile-sub-title> -->
                      </v-list-tile-content>
                    </v-list-tile>
                    <!-- </template> -->
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>

            <!-- <v-progress-circular class="ml-5 pl-5 mb-5" v-if="progress"
              :size="70"
              :width="5"
              color="grey"
              indeterminate
            ></v-progress-circular> -->

            <!-- <div v-if="processedArtwork" class="ml-3 pb-3">
              <v-card-title primary-title class="pt-0 mt-0">
                <div>
                  <h3 class="headline mb-0">{{processedArtwork.title}}</h3>
                  <div>
                    Artist: {{processedArtwork.full_name}} <br>
                    Accession Number: {{processedArtwork.accession_number}} <br>
                    Production Year: {{processedArtwork.production_date_new}}<br>
                  </div>
                </div>
              </v-card-title>
              <v-card-actions> 
                <v-btn color="primary" @click.native="addArtwork(processedArtwork.id)">Add artwork to Text</v-btn>
              </v-card-actions>
            </div> -->
          </v-card>

          <v-btn color="primary" @click.native="e1 = 2"
            ><v-icon class="pr-2">mdi-arrow-left-bold-box</v-icon>Back to
            Basic</v-btn
          >

          <!-- @click.native="updateText" -->
          <v-btn color="primary" :disabled="!valid" @click="updateText()"
            >Save and Continue</v-btn
          >
          <v-btn flat @click="$router.push('/texts')"
            >Cancel & go to Text List</v-btn
          >
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card
            color="grey lighten-4 elevation-0"
            class="mb-5 pl-3 pr-3 pb-3"
          >
            <v-flex xs12
              ><br />
              <h3 class="title mb-3">
                {{ text.title }}
                <!-- <span v-if="text.loan"> - (LOAN)</span>
                <span v-if="text.text_type == 1"> - (SOLO)</span>
                <span v-if="text.text_type == 2"> - (GROUP)</span> -->
              </h3>
              <!-- <v-btn color="primary" @click.native="pdf">Download PDF </v-btn>               -->

              <table class="mb-0 main">
                <tr>
                  <td>Text Type:</td>
                  <td>{{ text.text_type }}</td>
                </tr>
                <tr>
                  <td>Author(s):</td>
                  <td>{{ text.authors }}</td>
                </tr>
                <tr>
                  <td>Year:</td>
                  <td>{{ text.year }}</td>
                </tr>
                <tr>
                  <td>Place:</td>
                  <td>{{ text.place }}</td>
                </tr>
                <tr>
                  <td>Publisher:</td>
                  <td>{{ text.publisher }}</td>
                </tr>
                <tr>
                  <td>URL:</td>
                  <td>{{ text.url }}</td>
                </tr>
                <tr>
                  <td>Note:</td>
                  <td>{{ text.admin_note }}</td>
                </tr>
              </table>

              <table class="mt-3">
                <tr>
                  <td colspan="2"><b>Type of text / resource:</b></td>
                </tr>

                <tr v-if="text.tba == 1">
                  <td></td>
                  <td><v-icon small>check_circle</v-icon> TBA21 publication</td>
                </tr>

                <tr v-if="text.nontba == 1">
                  <td></td>
                  <td>
                    <v-icon small>check_circle</v-icon> NON TBA21 publication
                  </td>
                </tr>

                <tr v-if="text.article == 1">
                  <td></td>
                  <td>
                    <v-icon small>check_circle</v-icon> Article (magazine,
                    journal, etc)
                  </td>
                </tr>

                <tr v-if="text.artwork_text == 1">
                  <td></td>
                  <td>
                    <v-icon small>check_circle</v-icon> Text on artwork
                    (exhibition, website, social media etc)
                  </td>
                </tr>

                <tr v-if="text.publication == 1">
                  <td></td>
                  <td><v-icon small>check_circle</v-icon> Publication</td>
                </tr>

                <tr v-if="text.pr == 1">
                  <td></td>
                  <td><v-icon small>check_circle</v-icon> Press release</td>
                </tr>

                <tr v-if="text.artist_documents == 1">
                  <td></td>
                  <td>
                    <v-icon small>check_circle</v-icon> Documents received from
                    artist, gallery, etc
                  </td>
                </tr>

                <tr v-if="text.transcript == 1">
                  <td></td>
                  <td><v-icon small>check_circle</v-icon> Transcription</td>
                </tr>

                <tr v-if="text.work_text == 1">
                  <td></td>
                  <td>
                    <v-icon small>check_circle</v-icon> Work inherent text (part
                    of artwork)
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                </tr>

                <!-- <tr v-if="text.artworks">
                  <td style="height: 3em; vertical-align: bottom;" colspan="2">
                    Artworks:
                    <v-list two-line class="mx-0 mb-2" v-if="text.artworks">
                      <v-list-tile :key="item.id" v-for="item in text.artworks">
                        <v-list-tile-avatar>
                          <img
                            v-if="item.top_photo_id > 0"
                            v-bind:src="
                              'http://tb-cms.org/data/artwork/' +
                                item.id +
                                '/' +
                                item.top_photo_id +
                                '_th_big.jpg'
                            "
                          />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="`${item.title} (${item.production_date_new})`"
                          ></v-list-tile-title>
                          <v-list-tile-sub-title
                            v-html="item.full_name"
                          ></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </td>
                </tr>

                <tr v-if="text.artists">
                  <td style="height: 3em; vertical-align: bottom;" colspan="2">
                      Artists:              
                    <v-list one-line class="mx-0 mb-2">
                      <v-list-tile :key="item.id" v-for="item in text.artists">
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="`${item.name}`"
                          ></v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </td>
                </tr> -->
              </table>

              <v-btn color="primary" @click.native="e1 = 3">
                <v-icon class="mr-2">mdi-arrow-left-bold-box</v-icon>
                Back to Artwork Selection
              </v-btn>
              <v-btn flat @click="$router.push('/texts')"
                >go to Text List</v-btn
              >
            </v-flex>
          </v-card>

          <v-btn
            color="primary"
            @click="
              $router.push({
                name: 'EditText',
                params: { id: text.id, text: text },
                path: `/texts/edit/${text.id}`
              })
            "
          >
            Go to Text Edit Page
          </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { serverBus } from '../../main'
import Upload from '@/components/artworks/Upload'
import TextEditor from '../artworks/TextEditor'
import constants from '@/data/constants'
import axios from 'axios'
export default {
  data() {
    return {
      search: '',
      constants: constants,
      e1: 1,
      progress: false,
      countries: constants.COUNTRIES,
      temp_artwork: '',
      text_artworks: [],
      text_artists: [],
      // fields: fields,
      text: {
        id: '',
        content: '',
        artists: [],
        artist_ids: [],
        artworks: [],
        artwork_ids: [],
        title: '',
        institution: '',
        city: '',
        duration_start_year: '',
        duration_start_month: '',
        duration_start_day: '',
        country: '',
        duration_end_year: '',
        duration_end_month: '',
        duration_end_day: '',
        show_type: [],
        admin_note: '',
        created_by: '',
        last_update_by: '',
        loan: ''
      },
      report: {
        date: ''
      },
      success: false,
      menu: false,
      modal: false,
      menu2: false,
      autosave: true,
      result: '',
      result_a: ''
    }
  },
  created() {
    this.$store.dispatch('loadArtworks')
    this.$store.dispatch('loadArtists')
  },
  methods: {
    remove(item) {
      // this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
      // this.text.artworks = [...this.text.artworks]
      // console.log(item)
      // console.log(this.text.artworks)
      const index = this.text.artworks.indexOf(item)
      // console.log(index)
      if (index >= 0) this.text.artworks.splice(index, 1)
    },
    removeArtist(item) {
      // this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
      // this.text.artworks = [...this.text.artworks]
      // console.log(item)
      // console.log(this.text.artworks)
      const index = this.text.artists.indexOf(item)
      // console.log(index)
      if (index >= 0) this.text.artists.splice(index, 1)
    },

    // format_date (date,format="YYYY-MM-DD") {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format(format)
    // },
    // addArtwork(id) {
    //   var a = this.$store.state.artworks.find(a => a.id == id);
    //   if (!this.text_artworks.includes(a)) {
    //     this.text_artworks.push(a);
    //   }
    //   this.temp_artwork = "";
    //   this.result_a = "";
    // },
    getArwork(id) {
      this.progress = true
      let url = `${this.$globals.apiserver}/artworks/${id}.json`
      axios
        .get(url)
        .then(response => {
          this.result_a = response.data
          this.progress = false
        })
        .catch(error => {
          // console.log(error);
        })
    },
    saveText() {
      serverBus.$emit('showSnackbar', 'Saving text', 'black')
      if (
        this.text.duration_end_year &&
        this.text.duration_end_month &&
        this.text.duration_end_day
      ) {
        this.text.duration_end = this.format_date(
          new Date(
            this.text.duration_end_year,
            this.text.duration_end_month - 1,
            this.text.duration_end_day
          ),
          'YYYY-MM-DD'
        )
      }
      if (
        this.text.duration_start_year &&
        this.text.duration_start_month &&
        this.text.duration_start_day
      ) {
        this.text.duration_start = this.format_date(
          new Date(
            this.text.duration_start_year,
            this.text.duration_start_month - 1,
            this.text.duration_start_day
          ),
          'YYYY-MM-DD'
        )
      }
      this.text.category = 'artwork_text'
      this.text.created_by = this.c_user.id
      let url = `${this.$globals.apiserver}/artwork_texts.json`
      axios
        .post(url, { artwork_text: this.text })
        .then(response => {
          this.result = response.data
          this.text = response.data
          // this.$store.dispatch("addText", response.data);
          serverBus.$emit('showSnackbar', 'Text saved.', 'green')
          this.e1 = 2
        })
        .catch(error => {
          // console.log(error);
        })
    },
    updateText() {
      serverBus.$emit('showSnackbar', 'Updating text', 'black')
      // delete this.text.text_artworks;
      // delete this.text.text_artists;
      if (
        this.text.duration_end_year &&
        this.text.duration_end_month &&
        this.text.duration_end_day
      ) {
        this.text.duration_end = this.format_date(
          new Date(
            this.text.duration_end_year,
            this.text.duration_end_month - 1,
            this.text.duration_end_day
          ),
          'YYYY-MM-DD'
        )
      }
      if (
        this.text.duration_start_year &&
        this.text.duration_start_month &&
        this.text.duration_start_day
      ) {
        this.text.duration_start = this.format_date(
          new Date(
            this.text.duration_start_year,
            this.text.duration_start_month - 1,
            this.text.duration_start_day
          ),
          'YYYY-MM-DD'
        )
      }
      // console.log(this.text_artworks);
      // this.text.artwork_ids = this.text_artworks.map(ea => ea.id);
      this.text.artwork_ids = this.text.artworks
      this.text.artworks = this.text.artwork_ids
      this.text.last_update_by = this.c_user.id
      // this.text.artist_ids = this.text_artists.map(ea => ea.id);
      this.text.artist_ids = this.text.artists
      // this.text.artists = this.text.artist_ids;
      // console.log(this.text)
      let url = `${this.$globals.apiserver}/artwork_texts/${this.text.id}.json`
      axios
        .put(url, { artwork_text: this.text })
        .then(response => {
          this.result = response.data
          this.text = response.data
          // this.$store.dispatch('updateText',response.data)
          serverBus.$emit('showSnackbar', 'Text saved.', 'green')
          this.e1 = this.e1 + 1
        })
        .catch(error => {
          // console.log(error);
        })
    },
    clear() {
      this.$refs.form.reset()
    },
    pdf() {
      // download PDF
    }
  },
  computed: {
    start_date() {
      return `${this.text.duration_start_year}. ${this.text.duration_start_month}. ${this.text.duration_start_day}`
    },
    end_date() {
      return `${this.text.duration_end_year}. ${this.text.duration_end_month}. ${this.text.duration_end_day}`
    },
    valid() {
      return true //this.text.title;
    },
    processedArtwork() {
      let processedArtwork = this.result_a
      return processedArtwork
    },
    artworks() {
      return Object.assign([], this.$store.state.artworks)
    },
    artists() {
      return Object.assign([], this.$store.state.artists)
    }
  },
  components: {
    Upload,
    TextEditor
  }
}
</script>

<style scoped>
.main td {
  width: 370px;
  line-height: 2em;
  vertical-align: top;
}
/* label.v-label {
  color: black !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/texts/AddText.vue